import { androidAddCircle } from "react-icons-kit/ionicons/androidAddCircle";
import { edit } from "react-icons-kit/entypo/edit";
import { u274C } from "react-icons-kit/noto_emoji_regular/u274C";

export const EquipmentTreeActionIconGroup = {
  Add: {
    iconProps: {
      icon: androidAddCircle,
      size: 22
    },
    tooltipTitle: "Add",
  },
  Edit: {
    iconProps: {
      icon: edit,
      size: 22
    },
    tooltipTitle: "Edit",
  },
  Delete: {
    iconProps: {
      icon: u274C,
      size: 22
    },
    tooltipTitle: "Delete",
  },
};





// WEBPACK FOOTER //
// ./src/components/Common/EquipmentTree/library-schemas/EquipmentTreeActionIconGroup.js